<template>
	<div class="fuel container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>OVERVIEW BRIGHT PAYMENT POINT</h4>
			</div>

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-4">
						<ChartSalesMonthComparison />
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 mb-4">
						<ChartSalesMonthComparisonBySalesArea />
					</div>
				</div>

				<div class="row">
					<div class="col-md-4 mb-4">
						<TopTenProductYtd />
					</div>
					<div class="col-md-4 mb-4">
						<TopTenProductMonthly />
					</div>
				</div>

			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import ChartSalesMonthComparisonBySalesArea from '@/views/pages/PPOB/Component/ChartSalesMonthComparisonBySalesArea.vue'
import ChartSalesMonthComparison from '@/views/pages/PPOB/Component/ChartSalesMonthComparison.vue'
import TopTenProductYtd from '@/views/pages/PPOB/Component/TopTenProductYtd.vue'
import TopTenProductMonthly from '@/views/pages/PPOB/Component/TopTenProductMonthly.vue'

export default{
	extends: Fuel,
	components:{
		ChartSalesMonthComparison,
		ChartSalesMonthComparisonBySalesArea,
		TopTenProductYtd,
		TopTenProductMonthly,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		Footer
	},
	data() {
		return {
            value: 0,
            isChildRoute: false,
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	},
	computed: {

	},

    mounted() {
        this.hideNonChildren();
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/ppob';
        },
	}
}
</script>


<style>

  </style>
